module.exports = __webpack_public_path__ + "static/media/boy.f2ae03f5.png";